<div class="detail-content">
    <ng-content />
</div>
